import { CosmosTxV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { hashToHex } from '../../../../utils/crypto.js';
export class TxClient {
    /**
     * Encode a transaction to base64-encoded protobuf
     * @param tx transaction to encode
     */
    static encode(tx) {
        return Buffer.from(CosmosTxV1Beta1Tx.TxRaw.encode(tx).finish()).toString('base64');
    }
    /**
     * Decode a transaction from base64-encoded protobuf
     * @param tx transaction string to decode
     */
    static decode(encodedTx) {
        return CosmosTxV1Beta1Tx.TxRaw.decode(Buffer.from(encodedTx, 'base64'));
    }
    /**
     * Get the transaction's hash
     * @param tx transaction to hash
     */
    static hash(tx) {
        return hashToHex(TxClient.encode(tx));
    }
}
